import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Paper } from "@mui/material";
import { CardTitle } from "./index.js";
export const Card = ({ disablePadding, children, paperProps, title, ...cardTitleProps }) => (_jsxs(Box, { sx: { mb: 3 }, children: [(typeof title === "string" && (_jsx(CardTitle, { title: title, ...cardTitleProps }))) ||
            title, _jsx(Paper, { ...paperProps, sx: [
                !disablePadding ? { p: 2 } : {},
                ...(paperProps?.sx
                    ? Array.isArray(paperProps.sx)
                        ? paperProps.sx
                        : [paperProps.sx]
                    : []),
            ], children: children })] }));
//# sourceMappingURL=Card.js.map